import { useContext } from 'react';

import { parseQueryString } from 'utils/url';
import { useCurrentPage } from 'services/url';
import { consoleLog } from 'services/log/utils';

import PqlState from './PqlState';
import useSuggest from './useSuggest';
import { SEARCH_TYPE } from './consts';

const useCurrentDashboardSearch = () => {
  const page = useCurrentPage();
  const qs = parseQueryString();
  const pqlQuery = qs.q;

  if (!page) {
    consoleLog('ERROR', 'useCurrentDashboardSearch', '"page" is not defined');
  }

  const suggest = useSuggest({ query: pqlQuery, searchType: SEARCH_TYPE[page] });

  const { state, ...rest } = useContext(PqlState);
  const pageState = state[page];

  return {
    pqlQuery,
    page,
    ...pageState,
    ...rest,
    pqlTimerange: suggest.results?.timerange,
    suggestLoading: suggest.loading,
    suggestError: suggest.error,
    t1: suggest.results ? suggest.results.t1 * 1000 : undefined,
    t2: suggest.results ? suggest.results.t2 * 1000 : undefined,
  };
};

export default useCurrentDashboardSearch;
